/** Lets screens (e.g. modals) handle Android back before global navigation. */

type HardwareBackHandler = () => boolean;

const stack: HardwareBackHandler[] = [];

export function pushHardwareBackHandler(handler: HardwareBackHandler): () => void {
  stack.push(handler);
  return () => {
    const i = stack.lastIndexOf(handler);
    if (i >= 0) stack.splice(i, 1);
  };
}

/** @returns true if a handler consumed the back press */
export function consumeHardwareBack(): boolean {
  for (let i = stack.length - 1; i >= 0; i--) {
    if (stack[i]()) return true;
  }
  return false;
}
